<template>
  <div id="card-page">
    <MenuLayout />
    <div class="main-content">
      <StatusbarLayout />
      <div class="content-container">
        <div class="content">
          <div class="title">
            <h2>{{ $t("public.check_consumption_records") }}</h2>
            <!-- 按钮组 -->
            <!-- <div class="action-buttons">
              <div class="action-button" @click="getExportAllData">
                <img
                  src="@/assets/pages/card/export.png"
                  :alt="$t('public.export')"
                />
                <span>{{ $t("public.export") }}</span>
              </div>
            </div> -->
          </div>
          <!-- 筛选条件 -->
          <div class="wrap-select">
            <div class="select-1">
              <span class="select-1-span"
                >{{ $t("public.cell_title.card_uid") }}：</span
              >
              <el-input
                ref="cardUidRef"
                style="width: 120px"
                :placeholder="$t('public.cell_title.card_uid')"
                class="filter-input"
                v-model.trim="select.card_uid"
                @keydown.enter="search"
              />
            </div>
            <div class="select-1">
              <span class="select-1-span"
                >{{ $t("public.select_date_range") }}：</span
              >
              <el-date-picker
                style="max-width: 300px"
                v-model="select.date"
                type="daterange"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                :placeholder="$t('public.select_date_range')"
                :start-placeholder="$t('public.start_date')"
                :end-placeholder="$t('public.end_date')"
                class="filter-date-picker"
                @clear="dateClear"
              />
            </div>
            <el-button type="primary" @click="search">{{
              $t("public.search")
            }}</el-button>
            <el-button type="primary" @click="exportConsumptionLists">{{
              $t("public.export")
            }}</el-button>
          </div>
          <!-- 表格 -->
          <div class="table">
            <el-table
              :data="data"
              max-height="500"
              style="width: 100%"
              border
              :empty-text="$t('public.no_data')"
            >
              <el-table-column
                prop="card_uid"
                :label="$t('public.cell_title.card_uid')"
              />
              <el-table-column prop="detail" :label="$t('public.details')" />
              <el-table-column
                prop="amount"
                :label="$t('public.transaction_amount')"
              />
              <el-table-column prop="fee" :label="$t('public.commission')" />
              <el-table-column prop="status" :label="$t('public.status')" />
              <el-table-column prop="biz_time" :label="$t('public.biz_time')" />
            </el-table>
            <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pageInfo.total"
                :page-size="pageInfo.pageSize"
                v-model:current-page="pageInfo.page"
                @change="onChange"
              ></el-pagination>
            </div>
          </div>
          <!-- 刷新模态框 -->
          <el-dialog
            v-model="refreshDialogVisible"
            :title="$t('public.refresh')"
            :before-close="refreshCancelForm"
          >
            <el-form
              ref="refreshFormRef"
              :model="refreshForm"
              label-width="auto"
              status-icon
            >
              <el-form-item :label="$t('public.time')" prop="time">
                <el-date-picker
                  style="max-width: 300px; margin-left: 20px"
                  v-model="refreshForm.daterange"
                  type="daterange"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :placeholder="$t('public.select_date_range')"
                  :start-placeholder="$t('public.start_date')"
                  :end-placeholder="$t('public.end_date')"
                  class="filter-date-picker"
                />
                <el-button
                  type="primary"
                  style="margin-left: 20px"
                  @click="refreshCardLists"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MenuLayout from "@/components/layouts/MenuLayout.vue";
import StatusbarLayout from "@/components/layouts/StatusbarLayout.vue";
import { ref, reactive, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { exportExcel } from "@/utils/export/xlsx";
import { getCurrentInstance } from "vue";
import apiClient from "@/services/api";

const route = useRoute();
const {
  appContext: {
    config: { globalProperties },
  },
} = getCurrentInstance();

const cardUidRef = ref();

// 表格排序 - 与默认相同
const sortTime = (a, b) => {
  a.create_time - b.create_time;
};

// 获取数据列表
const data = ref();
const getTableList = async () => {
  const res = await apiClient.post("/records/consumption", {
    page: pageInfo.page,
    per_page: pageInfo.pageSize,
    start_time: select.value.date[0] ? select.value.date[0] : null,
    end_time: select.value.date[1] ? select.value.date[1] : null,
    card_uid: select.value.card_uid ? select.value.card_uid : null,
  });
  if (res.code == 0 && res.data) {
    data.value = res.data.items;
    pageInfo.page = res.data.page;
    pageInfo.pageSize = res.data.per_page;
    pageInfo.total = res.data.total_count;
  }
};

// 查询条件
const select = ref({
  date: [],
  card_uid: "",
});
const search = () => {
  getTableList();
};
const dateClear = () => {
  select.value.date = [];
};

// 分页改变-同步分页当前页数和页大小，重新调用
const pageInfo = reactive({
  page: 1,
  pageSize: 10,
  total: 0,
});
const onChange = (page, pageSize) => {
  pageInfo.page = page;
  pageInfo.pageSize = pageSize;
  getTableList();
};

// //xlsx表头
// const titleArr = ref([
//   globalProperties.$t("public.biz_id"),
//   globalProperties.$t("public.details"),
//   globalProperties.$t("public.transaction_amount"),
//   globalProperties.$t("public.fee"),
//   globalProperties.$t("public.status"),
//   globalProperties.$t("public.biz_time"),
// ]);

// // 获取所有数据并导出
// const exportPage = reactive({
//   page: 1,
//   per_page: 500,
//   total_pages: 2,
// });
// const exportData = ref([]);
// const getExportAllData = async () => {
//   while (exportPage.total_pages >= exportPage.page) {
//     const res = await apiClient.post("/records/consumption", exportPage);
//     if (parseInt(res.code) === 0 && res.data) {
//       if (exportData.value.length == res.data.total_count) {
//         break;
//       }
//       const filteredItems = res.data.items.map((item) => ({
//         biz_id: item.biz_id,
//         detail: item.detail,
//         amount: item.amount,
//         fee: item.fee,
//         status: item.status,
//         biz_time: item.biz_time,
//       }));
//       exportData.value = exportData.value.concat(filteredItems);
//       exportPage.page = res.data.page;
//       exportPage.per_page = res.data.per_page;
//       exportPage.total_pages = res.data.total_pages;

//       // 如果还有下一页，继续循环
//       if (exportPage.total_pages > exportPage.page) {
//         exportPage.page += 1;
//       } else {
//         break;
//       }
//     }
//   }
//   // 所有数据获取完成，导出 Excel
//   exportExcel(
//     exportData.value,
//     globalProperties.$t("public.check_consumption_records"),
//     titleArr.value,
//     globalProperties.$t("public.check_consumption_records")
//   );
// };

const exportConsumptionLists = async () => {
  try {
    const res = await apiClient.post(
      "/records/consumption/export",
      {
        page: pageInfo.page,
        per_page: pageInfo.pageSize,
        start_time: select.value.date[0] ? select.value.date[0] : null,
        end_time: select.value.date[1] ? select.value.date[1] : null,
        card_uid: select.value.card_uid ? select.value.card_uid : null,
      },
      {
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([res]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "consumption_list.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    ElMessage({
      message: globalProperties.$t("public.system_is_busy"),
      type: "error",
    });
    console.error("导出失败:", error);
  }
};

onMounted(() => {
  getTableList();
});
</script>

<style lang="scss" scoped>
#card-page {
  display: flex;
  background-color: #f7fafa;
  height: 100vh;
  font-family: Arial, sans-serif;
}
.main-content {
  width: 82%;
  background-color: #f7fafa;
}

.content-container {
  background: #ffffff;
  margin: 8px;
}

.content {
  background: #fff;
  margin: 20px;
  border-radius: 10px;
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
  /* max-width: 1350px; */
  margin: 0 auto;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

:deep .cell {
  white-space: nowrap !important; /* 强制文本在一行显示 */
  overflow: hidden !important; /* 隐藏超出容器的文本 */
  text-overflow: ellipsis !important; /* 溢出时显示省略号 */
  // padding: 10px 5px;
}
.copy {
  cursor: pointer;
}
.wrap {
  padding: 30px;
}
// 标题
.wrap-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.top-title {
  font-size: 20px;
}
// 查询条件
.wrap-select {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  margin: 20px 0;
  font-size: 16px;
  gap: 20px;
  .select-1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    .select-1-span {
      // min-width: 60px;
      margin-right: 15px;
    }
  }
}
// 按钮组
.top-group {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  .top-btns {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
}
// 表格
.table {
  margin-top: 20px;
  .card-refresh {
    width: 12px;
    height: 12px;
    cursor: pointer;
    margin-left: 10px;
  }
  .status-span {
    padding: 2px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .status-active {
    color: #17d000;
    background-color: #c5ffbe;
  }

  .status-frozen {
    color: #ff0000;
    background-color: #ffbebe;
  }

  .status-icon {
    margin-left: 1px;
    width: 10px;
    height: auto;
    position: relative;
  }
}

.action-buttons-container {
  display: flex;
  gap: 10px;
}

.action-buttons-container span {
  color: #4baaf4;
  font-size: 0.9rem;
  cursor: pointer;
}

.action-buttons-container span:hover {
  color: #0479d3;
  text-decoration: underline;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.action-button {
  display: flex;
  align-items: center;
  padding: 6px 20px;
  border: 1px solid #4baaf4;
  border-radius: 7px;
  cursor: pointer;
  background-color: #fff;
  font-size: 1rem;
  color: #4baaf4;
  gap: 10px;
}

.action-button img {
  width: 15px;
  height: 15px;
}

.action-button:hover {
  opacity: 0.7;
}
.card-container {
  display: flex;
  align-items: center;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>